{
  "title": "Privacy Policy",
  "preamble": [
    {
      "type": "paragraph",
      "parts": [{ "bold": "Last updated:" }, " February 1, 2026"]
    },
    {
      "type": "paragraph",
      "text": "PredictionHero (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains how we collect, use, and protect information when you use our website and services (the “Services”)."
    }
  ],
  "sections": [
    {
      "heading": {
        "level": 2,
        "title": "Information We Collect",
        "tone": "emphasized"
      },
      "blocks": [
        { "type": "paragraph", "text": "We may collect:" },
        {
          "type": "list",
          "items": [
            "Information you provide: such as your email address or messages sent to us",
            "Automatic data: IP address, browser type, device information, pages visited, and usage data collected via cookies or similar technologies"
          ]
        }
      ]
    },
    {
      "heading": {
        "level": 2,
        "title": "How We Use Information",
        "tone": "emphasized"
      },
      "blocks": [
        { "type": "paragraph", "text": "We use information to:" },
        {
          "type": "list",
          "items": [
            "Operate and improve the Services",
            "Communicate with users",
            "Analyze usage and performance",
            "Maintain security and prevent abuse"
          ]
        },
        {
          "type": "paragraph",
          "text": "We do not sell your personal information."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Cookies" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "We use cookies and similar technologies for functionality and analytics. You can control cookies through your browser settings."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Sharing of Information" },
      "blocks": [
        { "type": "paragraph", "text": "We may share information:" },
        {
          "type": "list",
          "items": [
            "With service providers who help operate the Services",
            "To comply with legal obligations",
            "In aggregated or anonymized form"
          ]
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Data Security" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "We use reasonable measures to protect your information, but no system is completely secure."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Your Choices" },
      "blocks": [
        {
          "type": "paragraph",
          "parts": [
            "You may opt out of marketing emails at any time and request access or deletion of your information by ",
            { "intercom": "contacting us." }
          ]
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Changes" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "We may update this policy from time to time. Continued use of the Services means you accept the updated policy."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Contact" },
      "blocks": [
        {
          "type": "paragraph",
          "parts": [
            "If you have any questions about these Terms, please ",
            { "intercom": "contact us." }
          ]
        }
      ]
    }
  ]
}
